<template>
	<div class="footer">
		<p>&copy; {{new Date().getFullYear()}} &#124; Conscius Bedrijfsrevisoren &#124; Gentsebaan 71A, bus 101 &#124; 9100 Sint-Niklaas &#124; Tel.: +32(0)3 777 75 79 &#124; Email: info@conscius-audit.eu</p>
	</div>
</template>

<script>
	export default {
		name: 'Footer',
	}


</script>

<style lang="scss">
	@import '../sass/footer.scss';
</style>
